import { Component, Input } from '@angular/core';
import { SinclairProsserComponent } from '../sinclair-prosser/sinclair-prosser.component';

@Component({
  selector: 'app-firm-info',
  templateUrl: './firm-info.component.html',
  styleUrls: ['./firm-info.component.scss']
})
export class FirmInfoComponent {
@Input() isSinclair=false;
}
